import { MessageSquare, Truck, Search, CheckCircle2, Wrench, PackageCheck } from "lucide-react";

const STEPS = [
  { icon: MessageSquare, title: "Submit Request", text: "Fill out the booking form with your device, the issue, and how you want to deliver it." },
  { icon: Truck, title: "Drop Off or Ship In", text: "Drop it at 67 Grand St, Susquehanna PA, or mail it in. Console only — PC must be in person." },
  { icon: Search, title: "Diagnostic", text: "I open it up and find the actual problem. No guesswork, no flat-rate gouging." },
  { icon: CheckCircle2, title: "You Approve Quote", text: "I send you a clear repair quote. You decide. No work happens without your green light." },
  { icon: Wrench, title: "Repair", text: "Quality parts, careful work. Most jobs done within a few days unless waiting on parts." },
  { icon: PackageCheck, title: "Pickup or Return Ship", text: "Pick it up locally or have it shipped back. Track status the whole way with your ticket #." },
];

export default function Process() {
  return (
    <section id="process" className="relative py-24 sm:py-32 border-t border-white/5" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="mb-16">
          <div className="font-mono text-xs tracking-[0.25em] uppercase text-zinc-500 mb-4">
            [ 03 ] · HOW IT WORKS
          </div>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tighter">
            Six steps. <span className="text-[#0055FF]">Zero surprises.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-zinc-800">
          {STEPS.map((s, idx) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                className="bg-[#0A0A0A] p-8 lg:p-10 hover:bg-[#121212] transition-colors"
                data-testid={`process-step-${idx + 1}`}
              >
                <div className="flex items-center justify-between mb-6">
                  <span className="font-mono text-xs tracking-[0.2em] text-zinc-600">
                    STEP / {String(idx + 1).padStart(2, "0")}
                  </span>
                  <Icon className="w-5 h-5 text-[#0055FF]" />
                </div>
                <h3 className="font-display font-semibold text-2xl mb-3 tracking-tight">{s.title}</h3>
                <p className="text-zinc-400 leading-relaxed">{s.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
